import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { COLORS } from '../../../../../../common/branding/colors';

export default class ColumnItemHighlighter extends PureComponent {
    render() {
        const { shouldRender, status } = this.props;
        if (!shouldRender || !status) {
            return (
                null
            );
        }

        return (
            <>
                <div
                    style={{
                        position: 'absolute',
                        height: 1,
                        width: '100%',
                        top: 0,
                        right: 0,
                        zIndex: 1,
                        background: COLORS.primary300,
                        opacity: 0.75,
                    }}
                />
                <div
                    style={{
                        position: 'absolute',
                        height: '100%',
                        width: 1,
                        top: 0,
                        right: 0,
                        zIndex: 1,
                        background: COLORS.primary300,
                        opacity: 0.75,
                    }}
                />
                <div
                    style={{
                        position: 'absolute',
                        height: 1,
                        width: '100%',
                        bottom: 0,
                        right: 0,
                        zIndex: 1,
                        background: COLORS.primary300,
                        opacity: 0.75,
                    }}
                />
                <div
                    style={{
                        position: 'absolute',
                        height: '100%',
                        width: 1,
                        top: 0,
                        left: 0,
                        background: COLORS.primary300,
                        opacity: 0.75,
                        zIndex: 1,
                    }}
                />
            </>
        );
    }
}

ColumnItemHighlighter.propTypes = {
    shouldRender: PropTypes.bool,
    status: PropTypes.string.isRequired,
};

ColumnItemHighlighter.defaultProps = {
    shouldRender: null,
};
